export default __webpack_public_path__ + "static/media/flag_gb.35dbacd7.svg";